function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.5354 12.4701C14.6334 12.4593 17.0285 9.62658 17.0343 6.23648C17.0286 2.84639 14.6335 0.012335 11.5354 0C8.43956 0.012335 6.04657 2.84639 6.03857 6.23648C6.04657 9.62658 8.43956 12.4593 11.5354 12.4701Z",
  fill: "#EFEFEF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.1088 13.0282C16.1088 13.0282 14.5026 17.9172 12.9524 20.3152C12.9041 18.6043 12.5868 17.1622 12.1406 16.4449C12.6258 16.1811 12.9625 15.6252 12.9625 14.9763C12.9625 14.0708 12.3136 13.3382 11.509 13.3382C10.7073 13.3382 10.057 14.0707 10.057 14.9763C10.057 15.6252 10.3944 16.1811 10.8797 16.4449C10.4355 17.1579 10.1182 18.5863 10.0678 20.2835C8.51913 17.8726 6.92358 13.0224 6.92358 13.0224C1.5797 14.2107 0.104511 17.4507 0 21.3145C0 22.9308 0.318766 24.6665 0.859486 26.3449H22.1455C22.6784 24.6613 23 22.9308 23 21.3145C22.8897 17.4651 21.4246 14.2257 16.1088 13.0282Z",
  fill: "#EFEFEF"
});

var SvgTradeProfileIcon = function SvgTradeProfileIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTradeProfileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trade-profile-icon.7ff7afa4.svg";
export { ForwardRef as ReactComponent };